// @flow
import * as React from 'react';
import Pill from 'components/Pill';
import Box from 'components/Box';
import { BodySmall } from 'components/Text';
import { colors } from '../theme';

const MultiPill = ({
  values,
  onDelete,
  idToLabelMap,
  emptyMessage,
  ...props
}: {
  values: Array<string>,
  onDelete: Function,
  idToLabelMap: Object,
  'data-qa-id': string,
  emptyMessage?: React.Node
}) => (
  <>
    {values.length > 0 ? (
      <Box
        display="flex"
        flexWrap="wrap"
        {...props}
        mx={[0, null, null, '-6px']}
        my="-4px"
        width={['100%', null, null, 'calc(100% + 12px)']}
      >
        {values.map((value, index) => (
          <Box
            py="4px"
            px="2px"
            maxWidth={['100%', '50%']}
            key={value}
            data-qa-id={props['data-qa-id'] + value}
          >
            <Pill
              onClick={() => onDelete(index)}
              text={idToLabelMap[value]}
              title={`Remove ${idToLabelMap[value]}`}
            />
          </Box>
        ))}
      </Box>
    ) : (
      emptyMessage && (
        <BodySmall color={colors.battleshipGrey}>{emptyMessage}</BodySmall>
      )
    )}
  </>
);

export default MultiPill;
